import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'atram-checkbox',
  templateUrl: './atram-checkbox.component.html',
  styleUrls: ['./atram-checkbox.component.less']
})
export class AtramCheckboxComponent implements OnInit {

  @Input() parentFormGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() isRequired: boolean | undefined = false;
  @Input() isError: boolean | undefined = false;
  @Input() isDisabled: boolean | undefined = false;
  @Input() componentClass!: string;
  @Output() onChangeEmitter: EventEmitter<boolean>;

  constructor() {
    this.onChangeEmitter = new EventEmitter<boolean>();
  }

  ngOnInit(): void {}

  public onChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.onChangeEmitter.emit(checked);
  }
}
